import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {
  Redirect,
  Route,
  Switch,
  withRouter
} from 'react-router-dom';
import Drawer from './components/Drawer/Drawer';
import Tulos from './Tulos';
import Tasevastaavaa from './TaseVastaavaa';
import Tasevastattavaa from './TaseVastattavaa';
import Login from './components/Login/Login';
import Receipt from './components/Receipt/Receipt';
import Lasku from './components/Lasku/Lasku';
import Omavero from './components/Omaverot/Omavero';
import Omaverot from './components/Omaverot/Omaverot';
import Ostolasku from './components/Ostolasku/Ostolasku';
import Ostolaskut from './components/Ostolaskut/Ostolaskut';
import Snackbar from './components/Snackbar/Snackbar';
import LoginDialog from './components/LoginDialog';
import LoginToCompany from './components/LoginToCompany';
import ChangePassword from './components/PasswordChange/PasswordChange';

@inject('authStore')
@withRouter
@observer
// Defines all routes in switch router
class App extends Component {

  render() {
    return (
      !this.props.authStore.authenticated ?
        <Login />
        :
        !this.props.authStore.companyAuthenticated ?
          <LoginToCompany />
          :
          <div className="app row">
            <Drawer />
            <LoginDialog />
            <Snackbar />
            <div className="app-content" >
              {/*Switch shows the first route it finds */}
              <Switch>
                <Route path="/tulos" component={Tulos} />
                <Route path="/tasevastaavaa" component={Tasevastaavaa} />
                <Route path="/tasevastattavaa" component={Tasevastattavaa} />
                <Route path="/tositteet/:id" component={Receipt} />
                <Route path="/omavero/:id" component={Omavero} />
                <Route path="/omavero" component={Omaverot} />
                <Route path="/laskut/:id" component={Lasku} />
                <Route path="/ostolaskut/:id" component={Ostolasku} />
                <Route path="/ostolaskut" component={Ostolaskut} />
                <Route path="/salasananvaihto" component={ChangePassword} />
                <Route exact path="/" render={() => <Redirect to="/tulos" />} />
              </Switch>
            </div>
          </div>
    );
  }
  
}

export default App;
